const UnitENGEnum = {
    MAN_DAY: 'Man-day',
    HOUR: 'Hour(s)',
    MONTH: 'Month',
    PCS: 'Pcs.'
  };

export default UnitENGEnum;